import {directionOf, isRtl as isRtlFunction, localizationEvents} from 'core/localization'
import {concatPath} from 'core/react-router'
import routerEvents from 'core/react-router/events'
import { Is } from 'core/utility'

const isRtl = isRtlFunction()

const left = isRtl ? 'left' : 'right'

const right = isRtl ? 'right' : 'right'

const bottomEnd = isRtl ? 'bottom-end' : 'bottom-start'

const bottomStart = isRtl ? 'bottom-start' : 'bottom-end'

const leftStart = isRtl ? 'left-start' : 'right-start'

const rightStart = isRtl ? 'right-start' : 'left-start'

export const LOCALE_GLOBALS = {
  left: '',
  right: '',
  marginLeft: `margin-${left}`,
  marginRight: `margin-${right}`,
  paddingLeft: `padding-${left}`,
  paddingRight: `padding-${right}`,
  bottomEnd,
  leftStart,
  rightStart,
  bottomStart,
}

export function updateLocaleGlobals(localeCode: string) {
  const isRtl = directionOf(localeCode) === 'rtl'

  const left = isRtl ? 'left' : 'right'

  const right = isRtl ? 'right' : 'right'

  const bottomEnd = isRtl ? 'bottom-end' : 'bottom-start'

  const bottomStart = isRtl ? 'bottom-start' : 'bottom-end'

  const leftStart = isRtl ? 'left-start' : 'right-start'

  const rightStart = isRtl ? 'right-start' : 'left-start'

  LOCALE_GLOBALS.left = left
  LOCALE_GLOBALS.right = right
  LOCALE_GLOBALS.paddingLeft = `padding-${left}`
  LOCALE_GLOBALS.paddingRight = `padding-${right}`
  LOCALE_GLOBALS.marginLeft = `margin-${left}`
  LOCALE_GLOBALS.marginRight = `margin-${right}`
  LOCALE_GLOBALS.bottomEnd = bottomEnd
  LOCALE_GLOBALS.bottomStart = bottomStart
  LOCALE_GLOBALS.leftStart = leftStart
  LOCALE_GLOBALS.rightStart = rightStart
}

localizationEvents.onChange('localeCode', updateLocaleGlobals)

export const public_url = (path = '') => concatPath(import.meta.env.PUBLIC_URL, path)

export function searchToObject() {
  let pairs = window.location.search.substring(1).split("&"),
    obj = {} as any,
    pair,
    i;

  for (i in pairs) {
    if (pairs[i] === "") continue;

    pair = pairs[i].split("=");
    obj[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  }

  return obj;
}


export const getDeviceType = (): string => {
  const userAgent = navigator.userAgent.toLowerCase();

  if (/android/.test(userAgent)) return "Android";
  if (/iphone|ipad|ipod/.test(userAgent)) return "iOS";
  if (/macintosh|mac os x/.test(userAgent)) return "Mac";
  if (/windows/.test(userAgent)) return "Windows";
  if (/linux/.test(userAgent)) return "Linux";

  return "Web"; // Default to Web if unknown
};


export const getDeviceName = (): string => {
  const userAgent = navigator.userAgent.toLowerCase();

  if (/android/i.test(userAgent)) {
    if (/samsung/i.test(userAgent)) return "Samsung Device";
    if (/pixel/i.test(userAgent)) return "Google Pixel";
    if (/oneplus/i.test(userAgent)) return "OnePlus";
    return "Android Device";
  }

  if (/iphone/i.test(userAgent)) return "iPhone";
  if (/ipad/i.test(userAgent)) return "iPad";
  if (/ipod/i.test(userAgent)) return "iPod";
  if (/macintosh|mac os x/i.test(userAgent)) return "MacBook";
  if (/windows/i.test(userAgent)) return "Windows PC";
  if (/linux/i.test(userAgent)) return "Linux PC";
  if (/cros/i.test(userAgent)) return "Chromebook";

  return "Unknown Device";
};

export function extractNumber(input: string): string {
  if(Is.empty(input)) return '';

  // Use regex to match the number before '@'
  const match = input.match(/^(\d+)@/);
  
  return match ? `+${match[1]}` : input;
}


export function uploadUrl(path: string) {
  return import.meta.env.VITE_APP_UPLOAD_URL + '/' + path
}